/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hoxsell-desktop[_ngcontent-%COMP%]{width:100%;display:block;border:0 solid #e2e8f0}.hoxsell-mobile[_ngcontent-%COMP%]{width:100%;display:none;border:0 solid #e2e8f0}@media screen and (max-width:350px){.hoxsell-desktop[_ngcontent-%COMP%]{width:100%;display:none;border:0 solid #e2e8f0}.hoxsell-mobile[_ngcontent-%COMP%]{width:100%;display:block;border:0 solid #e2e8f0}}\n/*# sourceMappingURL=cross-sell-promotion-widget.component.css.map*/"];
export { styles as styles };
